export default {
  fieldsWrapper: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    columnGap: '1rem'
  },
  uploadFile: {
    width: {
      xs: '100%',
      sm: '100%'
    },
    mt: '-.1rem',
    p: '11.72px .8rem'
  },
  fieldLabel: {
    color: 'font.dark',
    fontWeight: '600',
    mb: '1rem'
  },
  sectionTitle: {
    display: 'flex',
    alignItems: 'center',
    columnGap: '1rem',
    mb: '1.75rem',
    mt: '2.2rem'
  }
};
